import { GradientType, IFrame, IGradFill, IGradFillPoint } from '@tencent/alloy-graphics';
import { DisplayObject } from '@tencent/alloy-renderer';
import { DirectList } from '@editor/src/js/constants';

export function convertGradual(fill: string): IGradFill | undefined {
    if (fill.startsWith('l(')) {  // 线性渐变
        const dataList = fill.split(' ');
        if (dataList.length >= 3) {
            const ang = dataList[0].substring(2, dataList[0].length - 1);
            const gsList: IGradFillPoint[] = [];
            for (let i = 1; i < dataList.length; i++) {
                const splitP = dataList[i].split(':');
                gsList.push({ pos: Number(splitP[0]) * 100, color: splitP[1] });
            }
            return {
                gsList, lin: { ang: Number(ang) },
                pathGradient: { path: GradientType.Linear },
                rotateWithShape: false,
            };
        }
    } else if (fill.startsWith('r(')) {
        const dataList = fill.split(' ');
        if (dataList.length >= 3) {
            const radial = dataList[0].substring(2, dataList[0].length - 1);
            const gsList: IGradFillPoint[] = [];
            for (let i = 1; i < dataList.length; i++) {
                const splitP = dataList[i].split(':');
                gsList.push({ pos: Number(splitP[0]) * 100, color: splitP[1] });
            }
            return {
                gsList,
                pathGradient: { path: GradientType.Radial, fillToRect: getFillRectByRadial(radial) },
                rotateWithShape: false,
            };
        }
    }
}

/**
 * 数组长度为3，[0]为cx，[1]为cy，[2]为r
 * @param radial
 */
function getFillRectByRadial(radial: string) {
    const split =  radial.split(',').map(v => Number(v));
    let fillRect = {
        b: 50, l: 50, r: 50, t: 50,  // 默认为中心点
    };
    DirectList.forEach((directInfo) => {
        const { cx, cy, r } = directInfo.val;
        if (cx === split[0] && cy === split[1] && r === split[2]) {
            fillRect = directInfo.rect;
        }
    });
    return fillRect;
}

export function convertFrame(element: DisplayObject, strokeWidth = 0): IFrame {
    const initBounds = element.initialBounds;
    return {
        width: initBounds.width,
        height: initBounds.height,
        left: 0,
        top: 0,
        offsetFrame: {
            offsetX: initBounds.x - (strokeWidth / 2),
            offsetY: initBounds.y - (strokeWidth / 2),
            offsetWidth: initBounds.width + strokeWidth,
            offsetHeight: initBounds.height + strokeWidth,
        },
    };
}
